/* eslint-disable import/no-relative-parent-imports */
// eslint-disable-next-line import/no-unassigned-import
import '../scss/form.scss';
/* eslint-enable import/no-relative-parent-imports */

declare const formLabels: {
    [key: string]: string;
};

function setFocusToForm (): void {
    if (window.location.hash) {
        document.getElementById(window.location.hash.replace('#', ''))?.focus();
    }
}

function setErrorMessage (input: HTMLInputElement, errorDescription: string, errorMessage: string = ''): void {
    // Remove old error message element - TODO: remove also static error message of ext:form (duplicate messages!)
    const oldAlertElement = document.getElementById(input.id + '-alert');
    if (oldAlertElement) {
        input.parentElement?.removeChild(oldAlertElement);
    }

    if (errorDescription) {
        // Create error message element
        const alertElement = document.createElement('span');
        alertElement.setAttribute('class', 'error help-block');
        alertElement.setAttribute('id', input.id + '-alert');
        const errorNode = document.createTextNode(errorDescription);
        alertElement.appendChild(errorNode);
        input.parentElement?.appendChild(alertElement);

        input.setCustomValidity(errorMessage || errorDescription); // block form submission
        input.classList.add('error');
        input.setAttribute('aria-invalid', 'true');
        let describedBy = input.getAttribute('aria-describedby') || '';
        const escapedFieldId = input.id.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        const containsDescriptionIdRegeExp = new RegExp('(^| )' + escapedFieldId + '-alert($| )');
        if (!containsDescriptionIdRegeExp.test(describedBy)) {
            describedBy = ((input.getAttribute('aria-describedby') || '') + ' ' + input.id + '-alert').trim();
            input.setAttribute('aria-describedby', describedBy);
        }
    } else {
        input.setCustomValidity('');
        input.classList.remove('error');
        input.setAttribute('aria-invalid', 'false');
        const describedBy = input.getAttribute('aria-describedby')?.replace(input.id + '-alert', '').trim();
        input.setAttribute('aria-describedby', describedBy || '');
    }
}

function getSizeInBytes (size: string): number {
    const sizeParts = size.split(/(\d+)/).filter(Boolean);
    let sizeInBytes = 0;
    switch (sizeParts[1]) {
        case 'B':
            sizeInBytes = parseInt(sizeParts[0]);
            break;
        case 'KB':
            sizeInBytes = parseInt(sizeParts[0]) * 1024;
            break;
        case 'MB':
            sizeInBytes = parseInt(sizeParts[0]) * 1048576;
            break;
        case 'GB':
            sizeInBytes = parseInt(sizeParts[0]) * 1073741824;
            break;
    }
    return sizeInBytes;
}

function fileSizeValidator (input: HTMLInputElement): void {
    let minsize = 0;
    let maxsize = 0;
    let isValid = true;
    if (input.dataset.minsize) {
        minsize = getSizeInBytes(input.dataset.minsize);
    }
    if (input.dataset.maxsize) {
        maxsize = getSizeInBytes(input.dataset.maxsize);
    }
    if (input.files && input.files[0]) {
        if (minsize > 0 && input.files[0].size < minsize) {
            isValid = false;
            setErrorMessage(input,
                formLabels.fileTooSmall.replace('%s', input.dataset.minsize as string),
                formLabels.invalidFile
            );
        }
        if (maxsize > 0 && input.files[0].size > maxsize) {
            isValid = false;
            setErrorMessage(input,
                formLabels.fileTooLarge.replace('%s', input.dataset.maxsize as string),
                formLabels.invalidFile
            );
        }
    }
    if (isValid) {
        setErrorMessage(input, '');
    }
}

function socialInsuranceNumberValidator (value: string): void {
    const socialInsuranceNumberInput = (document.querySelector<HTMLElement>('.social-insurance-number')?.querySelector('input') as HTMLInputElement);
    let isValid = false;
    let errorMessage = '';

    if (/^[0-9]{10}$/.test(value)) {
        const number = value.split('');
        const multiplyTable = [3, 7, 9, 0, 5, 8, 4, 2, 1, 6];
        let sum = 0;
        for (let i = 0; i < 10; i++) {
            sum = sum + parseInt(number[i]) * multiplyTable[i];
        }
        const remainder = sum % 11;
        if (remainder === parseInt(number[3])) {
            isValid = true;
        } else {
            errorMessage = formLabels.socialInsuranceNumberInvalid;
        }
    } else if (value.trim() === '') {
        isValid = true;
    }

    if (isValid) {
        setErrorMessage(socialInsuranceNumberInput, '');
    } else {
        setErrorMessage(socialInsuranceNumberInput, formLabels.socialInsuranceNumberHint, errorMessage);
    }
}

function toggleIdNumberContainer (hasId: number): void {
    const idNumberContainer = document.querySelector<HTMLElement>('.id-number');
    const idNumberInput = idNumberContainer?.querySelector<HTMLElement>('input');
    if (idNumberContainer) {
        if (hasId === 1) {
            idNumberContainer.style.display = 'block';
            if (idNumberInput) {
                idNumberInput.setAttribute('required', 'required');
            }
        } else if (hasId === 0) {
            idNumberContainer.style.display = 'none';
            if (idNumberInput) {
                idNumberInput.removeAttribute('required');
            }
        }
    }
}

function idNumberInputValidator (): void {
    const hasIdRadios = document.querySelector('.has-id-number')?.querySelectorAll('input');
    if (hasIdRadios) {
        const selectedHasId = (document.querySelector('.has-id-number')?.querySelector('input:checked') as HTMLInputElement);
        if (selectedHasId) {
            toggleIdNumberContainer(parseInt(selectedHasId.value));
        }
        for (const hasIdRadio of hasIdRadios) {
            hasIdRadio.addEventListener('change', function () {
                toggleIdNumberContainer(parseInt(this.value));
            });
        }
    }
}

function enableValidation (): void {
    idNumberInputValidator();

    const socialInsuranceNumberInput = document.querySelector('.social-insurance-number')?.querySelector<HTMLInputElement>('input');
    if (socialInsuranceNumberInput) {
        socialInsuranceNumberInput.addEventListener('focusout', function () {
            socialInsuranceNumberValidator(this.value);
        });
    }

    const fileInputs = (document.querySelectorAll('input[type=file]') as NodeList);
    for (const fileInput of fileInputs) {
        if ((fileInput as HTMLInputElement).dataset.minsize
            || (fileInput as HTMLInputElement).dataset.maxsize
        ) {
            fileInput.addEventListener('change', function (this: HTMLInputElement) {
                fileSizeValidator(this);
            });
        }
    }
}

function updateFileCount (): void {
    const fileInputs = document.querySelectorAll<HTMLInputElement>('.file-input');
    let uploadedFilesNum = 0;
    for (const fileInput of fileInputs) {
        if (fileInput.value) {
            uploadedFilesNum = uploadedFilesNum + 1;
        }
        if (document.getElementById(<string>fileInput.getAttribute('id') + '-file-reference')) {
            uploadedFilesNum = uploadedFilesNum + 1;
        }
    }
    const uploadedFilesNumElem = document.querySelector('.uploaded-files-num');
    if (uploadedFilesNumElem) {
        uploadedFilesNumElem.textContent = uploadedFilesNum.toString();
    }
}

function setupFileInputDesign (): void {
    const containerElements = document.querySelectorAll<HTMLElement>('.file-upload');
    for (const containerElement of containerElements) {
        const removeButton = containerElement.querySelector<HTMLButtonElement>('.remove-upload-button');
        const uploadButton = containerElement.querySelector<HTMLButtonElement>('.upload-button');
        const fileInput = containerElement.querySelector<HTMLInputElement>('.file-input');
        const fileIdentifierText = containerElement.querySelector<HTMLElement>('.file-identifier');
        const fileNameText = containerElement.querySelector<HTMLElement>('.file-name');

        if (!removeButton || !uploadButton) {
            return;
        }

        uploadButton.addEventListener('click', function () {
            fileInput?.click();
        });

        fileInput?.addEventListener('change', function (e) {
            let fileName: string | undefined;
            if (fileInput.files && fileInput.files.length > 1) {
                fileName = (fileInput.getAttribute('data-multiple-caption') || '').replace('{count}', fileInput.files.length.toString());
            } else {
                fileName = (e.target as HTMLInputElement).value.split('\\').pop();
            }
            if (fileName && fileNameText) {
                fileNameText.innerHTML = fileName;
            }
            if (fileIdentifierText) {
                fileIdentifierText.style.display = 'inline';
            }
            uploadButton.style.display = 'none';
            removeButton.style.display = 'block';
            updateFileCount();
        });

        removeButton?.addEventListener('click', function () {
            uploadButton.style.display = 'block';
            removeButton.style.display = 'none';
            if (fileNameText) {
                fileNameText.innerHTML = '';
            }
            if (fileIdentifierText) {
                fileIdentifierText.style.display = 'none';
            }
            if (fileInput) {
                fileInput.value = '';
                const previouslyUploadedInput = document.getElementById(<string>fileInput.getAttribute('id') + '-file-reference');
                if (previouslyUploadedInput) {
                    fileInput.parentElement?.removeChild(previouslyUploadedInput);
                }
            }
            updateFileCount();
        });
    }
}

function submitForm (this: HTMLElement, event: MouseEvent): void {
    const button = this as HTMLButtonElement;
    if (!button.form) {
        return;
    }
    event.preventDefault();

    const formSubmitButtons = button.form.querySelectorAll<HTMLElement>('button[type=submit]');

    // Disable buttons on submit
    formSubmitButtons.forEach((button: HTMLElement) => ((<HTMLButtonElement>button).disabled = true));
    // Disabled elements are not being submitted, so copy value to hidden field
    const hiddenPageValue = document.createElement('input');
    hiddenPageValue.setAttribute('type', 'hidden');
    hiddenPageValue.setAttribute('name', button.name);
    hiddenPageValue.setAttribute('value', button.value);
    button.form.appendChild(hiddenPageValue);
    button.form.submit();

    // Enable buttons again after a delay
    setTimeout(function () {
        if (button.form) {
            button.form.removeChild(hiddenPageValue);
            formSubmitButtons.forEach((button: HTMLElement) => ((<HTMLButtonElement>button).disabled = false));
        }
    }, 5 * 60 * 1000);
}

function enableSubmit (): void {
    document.querySelectorAll<HTMLElement>('button[type=submit][disabled=disabled]')
        .forEach((button: HTMLElement) => {
            (<HTMLButtonElement>button).disabled = false;
            if (button.classList.contains('button-submit')) {
                button.addEventListener('click', submitForm);
            }
        });
}

function init (): void {
    setFocusToForm();
    enableValidation();
    setupFileInputDesign();
    updateFileCount();
    enableSubmit();
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
} else {
    init();
}
